import Loader from '@amzn/meridian/loader';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';

import { useAuth } from 'src/auth/AuthProvider';
import HelloWorld from 'src/components/home/HelloWorld';

/**
 * Root component. Internal Midway site: there is no login screen.
 * - authenticated: render the app.
 * - error: a redirect to Midway could not be initiated; show a message.
 * - configuring (default): resolving the session or navigating to Midway — show a loader.
 */
const App = () => {
  const { status } = useAuth();

  if (status === 'authenticated') {
    return <HelloWorld />;
  }

  if (status === 'error') {
    return (
      <Column alignmentHorizontal="center" spacing="large" spacingInset="large">
        <Text>Unable to sign in. Please refresh the page to try again.</Text>
      </Column>
    );
  }

  return (
    <Column alignmentHorizontal="center" spacing="medium" spacingInset="large">
      <Loader />
      <Text>Signing in with Midway…</Text>
    </Column>
  );
};

export default App;
